import { stock } from '@/data/stockImages';

// Ana yazı (hub). Hedef: kafe otomasyon sistemi, restoran otomasyon sistemi/programı.
export default [
  {
    t: 'p',
    text: 'Kafe ve restoran otomasyon sistemi, bir işletmenin günlük işlerini (sipariş almak, masaları takip etmek, hesap kapatmak, stoğu izlemek, satışları raporlamak) tek bir yazılımda toplayan sistemdir. Garsonun aldığı sipariş, kasadaki hesap ve gün sonundaki ciro aynı kayıttan beslenir. Kâğıt adisyon, ayrı bir stok defteri ve el ile tutulan gün sonu hesabı yerine tek bir panel kullanılır.',
  },
  {
    t: 'p',
    text: 'Bu yazıda bir otomasyon sisteminin hangi parçalardan oluştuğunu, kafe ile restoranda ihtiyaçların nerede ayrıştığını ve geçiş yapmadan önce nelere bakmanız gerektiğini anlatıyoruz.',
  },
  { t: 'h2', text: 'Otomasyon sistemi ne işe yarar?' },
  {
    t: 'p',
    text: 'Küçük bir kafede bile gün içinde yüzlerce küçük kayıt oluşur: hangi masaya ne gitti, kim ne kadar ödedi, hangi ürün bitmek üzere. Bunlar kâğıtta ya da akılda tutulduğunda hata çıkması kaçınılmaz. Yoğun saatte bir siparişin yanlış masaya yazılması, açık kalan bir hesabın unutulması ya da sütün cumartesi öğleden sonra bitmesi bu tür kayıt açıklarından doğar.',
  },
  {
    t: 'p',
    text: 'Otomasyon sistemi bu kayıtları siparişin girildiği anda tutar ve herkesin aynı bilgiyi görmesini sağlar. Pratikte dört şeyi kolaylaştırır:',
  },
  {
    t: 'list',
    items: [
      '**Sipariş ve masa takibi:** Hangi masanın dolu olduğu, açık hesabın ne kadar tuttuğu ve siparişin hangi aşamada olduğu tek ekranda görünür.',
      '**Hesap kapatma:** Ödeme yöntemi seçilerek hesap kapatılır; hesabı bölmek ya da siparişi başka masaya taşımak birkaç dokunuşla yapılır.',
      '**Stok ve maliyet:** Ürünlere reçete tanımlandığında her satış stoktan otomatik düşer, ürün başına maliyet görünür hale gelir.',
      '**Raporlama:** Günlük ve aylık ciro, en çok satan ve en çok kazandıran ürünler ayrıca hesap yapmadan çıkar.',
    ],
  },
  {
    t: 'guide',
    image: '05-masalar-hazir',
    alt: 'Otomasyon panelinde masaların listelendiği ana ekran',
    caption: 'Masalar ekranı: dolu ve boş masalar, açık hesap toplamı tek bakışta.',
  },
  { t: 'h2', text: 'Bir otomasyon sistemi hangi modüllerden oluşur?' },
  {
    t: 'p',
    text: 'Sistemler farklı adlar kullansa da kafe ve restoran yazılımlarında benzer modüller bulunur. Aşağıdaki tablo her modülün ne yaptığını ve işletmede kimin kullandığını özetliyor.',
  },
  {
    t: 'table',
    head: ['Modül', 'Ne yapar?', 'Kim kullanır?'],
    rows: [
      ['Masa ve sipariş', 'Siparişi masaya kaydeder, masa durumunu ve açık hesabı gösterir', 'Garson, şef garson'],
      ['Hesap ve ödeme', 'Nakit, kart, yemek kartı ile hesap kapatma; parçalı ödeme, masa aktarma', 'Kasa, şef garson'],
      ['QR menü', 'Menüyü müşterinin telefonunda açar; isteğe bağlı olarak masadan sipariş alır', 'Müşteri, garson'],
      ['Stok ve reçete', 'Satıştan stok düşer, kritik seviyede uyarır, ürün maliyetini hesaplar', 'Yönetici, mutfak'],
      ['Raporlar', 'Günlük/aylık ciro, ürün bazında satış ve kâr', 'İşletme sahibi, yönetici'],
      ['Personel ve yetki', 'Her çalışanın hangi ekranları görüp neyi değiştirebileceğini belirler', 'İşletme sahibi'],
      ['Kampanya ve sadakat', 'Puan, ödül ve kampanya tanımlar; tekrar gelen müşteriyi tanır', 'Kasa, müşteri'],
    ],
  },
  {
    t: 'p',
    text: 'Her işletmenin hepsine ilk günden ihtiyacı olmaz. Çoğu işletme masa, sipariş ve hesap modülüyle başlar; QR menü, stok ve sadakat zamanla devreye girer. Bu yüzden modüllerin ayrı ayrı mı ücretlendirildiğini, yoksa tek bir paketin içinde mi geldiğini baştan öğrenmek faydalı olur.',
  },
  {
    t: 'p',
    text: 'Modüllerin her birini ayrı yazılarda ele aldık: [kafe sipariş sistemi](/blog/kafe-siparis-sistemi-nedir), [QR menü](/blog/qr-menu-nedir) ve [QR kod ile masadan sipariş](/blog/qr-kod-ile-masadan-siparis), [stok takibi](/blog/stok-takibi-nasil-yapilir) ve [ürün maliyeti hesabı](/blog/urun-maliyeti-nasil-hesaplanir), [dijital sadakat kartı ve puan sistemi](/blog/dijital-sadakat-karti-ve-puan-sistemi).',
  },
  { t: 'h2', text: 'Kafe ve restoranda ihtiyaçlar nasıl ayrışır?' },
  {
    t: 'img',
    img: stock('kafe-ic-mekan', 'Akşam ışığında ahşap masalı bir kafenin iç mekânı'),
  },
  {
    t: 'p',
    text: '“Kafe otomasyonu” ile “restoran otomasyonu” çoğu zaman aynı yazılımı anlatır; fark, hangi modülün daha çok iş gördüğündedir.',
  },
  { t: 'h3', text: 'Kafelerde öne çıkanlar' },
  {
    t: 'p',
    text: 'Kafelerde sipariş kısa ve sıktır, masa devri hızlıdır. Menüdeki ürünlerin çoğu birkaç ortak malzemeden (kahve, süt, şurup) hazırlandığı için **reçeteli stok takibi** burada çok işe yarar: bir latte satıldığında hangi malzemenin ne kadar azaldığı otomatik izlenir. Müşterilerin önemli bir kısmı düzenli geldiği için **sadakat programı** da kafelerde daha doğrudan karşılık bulur.',
  },
  { t: 'h3', text: 'Restoranlarda öne çıkanlar' },
  {
    t: 'p',
    text: 'Restoranlarda masa sayısı ve sipariş başına kalem sayısı daha yüksektir. Salon ile mutfak arasındaki koordinasyon, **sipariş notları** (az pişmiş, soğansız), kalabalık masalarda **hesabı bölme** ve masa değiştiren müşteriler için **masa aktarma** daha sık gerekir. Yemeklerin reçetesi çok kalemli olduğundan ürün maliyetini elle hesaplamak zorlaşır; bu yüzden maliyet hesabı restoranlarda ayrı bir önem taşır.',
  },
  {
    t: 'p',
    text: 'Masa sayısı arttıkça masaların ekranda nasıl gösterildiği de önem kazanır. Bazı sistemler salonu bir restoran krokisi üzerinde gösterir, bazıları masaları bölgelere göre gruplar; farkını [restoran kroki sistemi](/blog/restoran-kroki-sistemi) yazısında anlattık.',
  },
  { t: 'h2', text: 'Kâğıt adisyon ve yazarkasa ile farkı' },
  {
    t: 'p',
    text: 'Kâğıt adisyon siparişi kaydeder ama kaydı paylaşmaz. Mutfak, kasa ve yönetici aynı bilgiyi ancak kâğıt elden ele geçtikçe görür. Gün sonunda adisyonların toplanıp hesaplanması gerekir; hangi ürünün ne kadar sattığını görmek için ayrıca sayım yapılır.',
  },
  {
    t: 'p',
    text: 'Yazarkasa (ÖKC) ise mali fiş kesmek için vardır; masaları, açık hesapları ya da stoğu takip etmez. Otomasyon sistemi yazarkasanın yerini tutmaz, onun öncesindeki işi düzenler: sipariş alınır, masaya işlenir, hesap hazırlanır. Mali fiş ve belge yükümlülükleri ayrıca devam eder.',
  },
  { t: 'h2', text: 'Otomasyon sistemi seçerken nelere bakılmalı?' },
  {
    t: 'p',
    text: 'Seçim yaparken demo ekranındaki görüntüden çok, yoğun bir günde sistemin nasıl davranacağını düşünmek gerekir. Şu sorular işe yarar:',
  },
  {
    t: 'list',
    items: [
      'Garsonlar kendi telefonlarından ya da tabletten kullanabiliyor mu, yoksa ayrı bir cihaz almak mı gerekiyor?',
      'Bir cihazda girilen sipariş diğer cihazlarda anında görünüyor mu?',
      'Personel yetkileri ayrılabiliyor mu? Garsonun rapor ya da fiyat ekranına erişmemesi gerekir.',
      'QR menü, stok ve sadakat aynı sistemin içinde mi, yoksa ayrı hizmetler mi?',
      'Fiyatlandırma modül başına mı, tek paket mi? Kurulum ya da bakım ücreti var mı?',
      'Takıldığınızda destek hangi kanaldan ve ne kadar sürede geliyor?',
    ],
  },
  {
    t: 'p',
    text: 'Satın almadan önce sistemi kendi menünüzle denemek, bu soruların çoğunu birkaç günde cevaplar. Daha ayrıntılı bir kontrol listesi için [kafe ve restoran yönetim programı seçimi](/blog/kafe-restoran-yonetim-programi-secimi), Türkiye’deki sağlayıcı türleri için [Türkiye’de restoran teknoloji şirketleri](/blog/turkiyede-restoran-teknoloji-sirketleri) yazısına bakabilirsiniz.',
  },
  { t: 'h2', text: 'Tilki Otomasyon’da nasıl görünüyor?' },
  {
    t: 'p',
    text: 'Tilki Otomasyon bu modüllerin hepsini tek bir panelde toplar. Panel tarayıcıda ve iOS/Android uygulamasında çalışır; garson siparişi telefonundan girdiğinde masa, kasa ve raporlar aynı anda güncellenir. Kurulumdan hesap kapatmaya kadar her adımı [kullanım rehberinde](/nasil-kullanilir) ekran görüntüleriyle anlattık. QR menüyü nasıl kuracağınızı merak ediyorsanız [QR menü nasıl oluşturulur](/blog/qr-menu-nasil-olusturulur) yazısına bakabilirsiniz.',
  },
  {
    t: 'guide',
    image: '15-raporlar',
    alt: 'Raporlar ekranında günlük ciro ve en çok satan ürünler',
    caption: 'Raporlar: günlük ve aylık ciro, ürün bazında satış.',
  },
  {
    t: 'cta',
    title: 'Kendi işletmenizde görmek ister misiniz?',
    text: 'Ücretsiz demo talep edin; sistemi kendi menünüz ve masa düzeninizle birlikte gösterelim.',
    to: '/demo',
    label: 'Ücretsiz demo alın',
  },
];

export const faq = [
  {
    q: 'Restoran otomasyon sistemi ile yazarkasa aynı şey mi?',
    a: 'Hayır. Yazarkasa (ÖKC) mali fiş kesmek için kullanılır. Otomasyon sistemi ise siparişi, masaları, açık hesapları ve stoğu yönetir. İkisi birlikte kullanılır; otomasyon sistemi yazarkasa yükümlülüğünü ortadan kaldırmaz.',
  },
  {
    q: 'Küçük bir kafe için otomasyon sistemi gerekli mi?',
    a: 'Birkaç masalı bir kafe kâğıt adisyonla da idare edebilir. Ancak menü büyüdükçe, personel sayısı arttıkça ya da stok ve maliyeti takip etmek istediğinizde kâğıt kayıt yetersiz kalır. Aylık abonelikli bulut sistemler, küçük işletmeler için de başlangıç maliyetini düşük tutar.',
  },
  {
    q: 'Otomasyon sistemi için özel donanım almak gerekir mi?',
    a: 'Bulut tabanlı sistemlerde genellikle gerekmez; mevcut bilgisayar, tablet ve telefonlar yeterlidir. Tilki Otomasyon tarayıcıda ve iOS/Android uygulamasında çalışır, ayrı bir terminal satın almanız gerekmez.',
  },
];
